<template>
    <modal-dialog
        ref="commentModal"
        label="Notitie"
        description="Hier kun je de notitie lezen"
    >
        <flex-container :gap="Size.xs">
            <text-heading>
                Notitie
            </text-heading>

            <slot name="subheading" />
        </flex-container>

        <flex-container>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div class="comment-modal__comment" v-html="props.comment" />
        </flex-container>
    </modal-dialog>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
        type ExposedOverlay,
        ModalDialog,
        Size,
        TextHeading,
    } from '@keyvue/one-ui';

    import { ref } from 'vue';

    const props = defineProps<{
        comment?: string,
    }>();

    const commentModal = ref<ExposedOverlay>();

    defineExpose({
        openOverlay: () => {
            commentModal.value?.openOverlay();
        },
    });
</script>

<style scoped lang="scss">
.comment-modal__comment {
    margin-top: size(md);
    padding: size(md);
    background-color: color(gray-200);
    border-radius: size(sm);
    line-height: size(md);
    width: 100%;
    white-space: pre-line;
}
</style>
